// extracted by mini-css-extract-plugin
export default {"menu":"Menu-module__menu___0dm0g","menuItem":"Menu-module__menuItem___pJ74a","menuLink":"Menu-module__menuLink___4paTW"};